import { localStorageInstance } from '../instances/localStorageInstance';

const KEY_NAME = 'GEM_VIDEO_PLAYER_CONFIG';

export function set(config: string): void {
  return localStorageInstance.setItem(KEY_NAME, config);
}

export function get(): string | null {
  return localStorageInstance.getItem(KEY_NAME);
}
